export type WorkspaceMemberRole = "ADMIN" | "MEMBER" | "VIEWER";

const ORG_ROLE_LABELS: Record<string, string> = {
  owner: "Owner",
  admin: "Admin",
  manager: "Manager",
  member: "Member",
  viewer: "Viewer",
};

export function formatOrgRoleLabel(orgRole: string): string {
  const normalized = orgRole.trim().toLowerCase();
  return ORG_ROLE_LABELS[normalized] ?? orgRole;
}

export function mapOrgRoleToWorkspaceRole(orgRole: string): WorkspaceMemberRole {
  switch (orgRole.trim().toLowerCase()) {
    case "owner":
    case "admin":
    case "manager":
      return "ADMIN";
    case "viewer":
      return "VIEWER";
    case "member":
    default:
      return "MEMBER";
  }
}
